var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 216",
    style: {
      enableBackground: "new 0 0 792 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n \t.st0{display:none;}\n \t.st1{display:inline;fill:#666766;}\n \t.st2{fill:currentColor;}\n\t.st3{fill:#ffffff;}\n ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M444.38,143.88V83.19h-34.42V71.91h81.7v11.28h-34.43v60.69H444.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.61,114.52c-8.26,6.2-17.86,6.37-35.91,6.36l-26.69-0.33v23.33h-12.97V71.91l41.61,0.33 c15.38,0,26.35-0.56,33.69,5.01c5.62,4.1,5.88,11.48,5.88,18.94C303.23,103.55,303.12,110.42,297.61,114.52z M267.25,81.59 l-32.24-0.33v30.05l32.35,0.33c19.51,0,24.29-3.15,24.29-15.24C291.65,83.06,284.35,81.59,267.25,81.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M325.12,138.13c-7.7-5.36-9.21-12.4-9.21-24.27V71.94h13.06v41.08c0,7.46,0.93,11.52,5.95,15.62 c4.9,4.2,13.06,3.85,21.93,3.85c8.51,0,16.91,0.46,22.04-3.74c5.01-3.99,5.83-7.95,5.83-15.41v-41.4h12.83v41.93 c0,11.77-1.63,19.02-9.33,24.38c-8.75,6.09-20.41,5.64-31.49,5.64C345.29,143.87,333.75,144.23,325.12,138.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M538.46,143.88V83.19h-34.42V71.91h81.7v11.28h-34.43v60.69H538.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M663.87,143.88l-23.06-27c-3.54,0-4.82,0-7.34,0h-22.38v27h-12.97V71.91h37.53c15.38,0,25.7-0.62,33.16,4.42 c5.39,3.68,6.41,10.39,6.41,17.64c0,7.15-0.67,13.91-6.18,17.8c-3.44,2.73-8.04,3.14-13.77,3.64l24.56,28.47H663.87z  M639.47,81.26h-28.38v26.48h28.5c17.67,0,24.06-1.68,24.06-13.45C663.65,82.31,655.88,81.26,639.47,81.26z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.99,55.73L110.99,55.73c-1.89,0-3.41-1.53-3.41-3.41V24.43c0-1.89,1.53-3.41,3.41-3.41h0c1.89,0,3.41,1.53,3.41,3.41 v27.89C114.41,54.21,112.88,55.73,110.99,55.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.01,36.98v6.98c27.76,7.49,48.2,32.85,48.2,62.98c0,36.03-29.21,65.24-65.24,65.24s-65.24-29.21-65.24-65.24 c0-30.09,20.37-55.42,48.07-62.95v-6.98c-31.48,7.7-54.84,36.09-54.84,69.94c0,39.76,32.24,72,72,72s72-32.24,72-72 C182.97,73.05,159.55,44.63,128.01,36.98z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 110.97,
    cy: 107.96,
    r: 17.02
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.89,144.91c-5.36,5.36-9.15,7.13-9.15,7.13c-2.56,1.24-5.64,0.67-7.7-3.02c-2.06-3.7-5.34-12.38-5.99-14.69 c-0.65-2.31,0.13-4.04,2.18-6.03c1.19-1.19,2.02-2.02,2.02-2.02s0.83-0.83,2.02-2.02c1.99-2.06,3.72-2.84,6.03-2.18 S148.3,126,152,128.06c3.7,2.06,4.26,5.14,3.02,7.7C155.02,135.76,153.3,139.51,147.89,144.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.08,71.1c-5.36,5.36-7.13,9.15-7.13,9.15c-1.24,2.56-0.67,5.64,3.02,7.7c3.7,2.06,12.38,5.34,14.69,5.99 c2.31,0.65,4.04-0.13,6.03-2.18c1.19-1.19,2.02-2.02,2.02-2.02s0.83-0.83,2.02-2.02c2.06-1.99,2.84-3.72,2.18-6.03 C96.27,79.38,93,70.7,90.94,67c-2.06-3.7-5.14-4.26-7.7-3.02C83.24,63.98,79.49,65.7,74.08,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.85,71c5.36,5.36,7.13,9.15,7.13,9.15c1.24,2.56,0.67,5.64-3.02,7.7c-3.7,2.06-12.38,5.34-14.69,5.99 c-2.31,0.65-4.04-0.13-6.03-2.18c-1.19-1.19-2.02-2.02-2.02-2.02s-0.83-0.83-2.02-2.02c-2.06-1.99-2.84-3.72-2.18-6.03 S128.94,70.6,131,66.9c2.06-3.7,5.14-4.26,7.7-3.02C138.7,63.88,142.45,65.6,147.85,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.04,144.81c5.36,5.36,9.15,7.13,9.15,7.13c2.56,1.24,5.64,0.67,7.7-3.02s5.34-12.38,5.99-14.69 c0.65-2.31-0.13-4.04-2.18-6.03c-1.19-1.19-2.02-2.02-2.02-2.02s-0.83-0.83-2.02-2.02c-1.99-2.06-3.72-2.84-6.03-2.18 s-10.99,3.93-14.69,5.99c-3.7,2.06-4.26,5.14-3.02,7.7C66.91,135.66,68.64,139.41,74.04,144.81z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo_header.fbb40e2109353a8c74b4e09a1e895c33.svg";
export { ForwardRef as ReactComponent };